/**
 * 
 * @returns 
 */
export const designHuddleController = () => ({
    currentPage: 'introduction',
    previousPage: '',
    changePage(next, prev) {
        let prevPage = prev ?? this.currentPage
        this.currentPage = next ?? this.previousPage
        this.previousPage = prevPage
    },
    goToPrev() {
        let next = this.previousPage
        let prev = this.currentPage
        this.changePage(next, prev)
    }
})